export default __webpack_public_path__ + "static/media/360.48abded9.jpeg";